<template>
  <div class="font-uploader-box">
    <el-upload
      ref="uploader"
      :multiple="multiple"
      :show-file-list="false"
      :action="font_upload_url"
      :on-change="onChange"
      :before-upload="onBefore"
      :on-progress="onProgress"
      :on-success="onSuccess"
      :accept="acceptFileTypeList.join(',')"
      list-type="picture"
    >
      <slot v-if="$slots.default"></slot>
      <el-button
        v-else
        size="small"
        :type="btnType"
        :loading="loading"
        >{{ btnName }}</el-button
      >
    </el-upload>
    <el-dialog
      title="字体上传"
      class="global-dialog font-uploader-dialog"
      width="550px"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-show="uploadStatus === 'ready'" class="font-uploader-box-wrap">
        <span>解析并上传字体，请稍后</span><br>
        <el-progress :percentage="uploadProcess" :stroke-width="12"></el-progress>
      </div>
      <div v-show="uploadStatus === 'error'" class="font-uploader-box-wrap">
        <span>字体上传失败，请重新上传</span><br>
        {{ uploadFontName || '' }}
      </div>
      <div v-show="uploadStatus === 'parse-error'" class="font-uploader-box-wrap">
        <span class="error">字体解析失败</span><br>
        可能的原因：该字体无法在自助制图系统中使用，请检查字体文件或格式。
      </div>
      <div v-show="uploadStatus === 'success'" class="font-uploader-box-wrap">
        <span>字体已成功上传！</span><br>
        {{ uploadFontName || '' }}
      </div>
      <div v-show="uploadStatus === 'exist'" class="font-uploader-box-wrap">
        <span>该字体已存在，上传后将替换原字体文件，是否继续上传？</span><br>
        {{ uploadFontName || '' }}
      </div>
      <div slot="footer">
        <el-button :type="uploadStatus === 'success' || uploadStatus === 'error' ? 'primary' : ''" @click="dialogVisible = false">
          {{ uploadStatus === 'success'  || uploadStatus === 'error' ? '关闭' : '取消' }}
        </el-button>
        <el-button v-show="uploadStatus === 'exist'" type="primary" @click="saveFont">继续上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { font_upload_url } from '@/request/api/font-api'
import fontService from '@/request/service/font-service'
import util from '@/util.js'
import FontUtil from '../FontUtil'

const font_type = ['.ttf', '.otf']
let uploadData = null
export default {
  components: {},
  props: {
    projectId: String,
    fontName: String, //替换字体主名
    autoSave: { type: Boolean, default: true },
    btnType: { type: String, default: 'primary' },
    btnName: { type: String, default: '上传字体' },
    successMsg: String
  },
  data () {
    let fontTypeList = []
    font_type.forEach(item => {
      fontTypeList.push(item)
      fontTypeList.push(item.toUpperCase())
    })
    return {
      dialogVisible: false,
      uploadStatus: 'ready',
      uploadProcess: 0,
      uploadFontName: '',
      multiple: false,
      font_upload_url,
      fileList: [],
      acceptFileTypeList: fontTypeList,
      loading: false
    }
  },
  computed: {
    uploading () {
      return this.fileList.some(item => {
        return item.percentage !== 100 && item.errorMsg === ''
      })
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val && this.uploadStatus === 'success') {
        console.log('uploadFontId', this.uploadFontId)
        this.$emit('onAdd', this.uploadFontId)
        // this.$emit('onAdd', this.emitType, uploadData, this.emitUploadData)
      }
    }
  },
  methods: {
    onBefore (file) {
      uploadData = null
      this.uploadFontName = ''
      this.uploadStatus = 'ready'
      this.uploadProcess = 0
      this.dialogVisible = true
      this.uploadTimeFlag = new Date().getTime()
    },
    onChange (file) {},
    onProgress (event, file, fileList) {
      this.uploadProcess = parseInt(file.percentage) > 99 ? 99 : parseInt(file.percentage)
    },
    onSuccess (response, file, fileList) {
      if (response.code === 200) {
        this.parseFont(response.result[0].url)
      } else {
        return this.uploadStatus = 'error'
      }
    },
    getCoverAndView (fontUrl, fontName, text) {
      return Promise.all([FontUtil.createFontCover(fontUrl, fontName), FontUtil.createFontView(fontUrl, fontName, text)])
    },
    parseFont (url) {
      const data = {
        url
      }
      this.projectId && (data.projectId = this.projectId)
      fontService.parseFont(data).then(res => {
        if (res.code === 200) {
          this.uploadFontName = `字体名称：${res.result.fontFamily}`
          this.getCoverAndView(res.result.url, res.result.psName, `${res.result.fontFamily}-${res.result.weight}`).then(urls => {
            uploadData = res.result
            uploadData.cover = urls[0]
            uploadData.preview = urls[1]
            if (res.result.exist) {
              this.uploadStatus = 'exist'
            } else {
              this.saveFont('add')
            }
          }).catch(() => {
            this.uploadStatus = 'parse-error'
          })
        } else {
          this.uploadStatus = 'parse-error'
        }
      }).catch(() => {
        this.uploadStatus = 'parse-error'
      })
    },
    saveFont (type = 'upload') {
      let data = uploadData
      let promiseResult
      if (this.projectId) {
        data.uploadByProj = this.projectId
        data.projectId = this.projectId
        promiseResult = fontService.addFontByProject(data)
      } else {
        promiseResult = fontService.addFontByAdmin(data)
      }
      promiseResult
        .then((d) => {
          console.log(123, d)
          this.uploadStatus = 'success'
          this.uploadFontId = d
          // this.$emit('onAdd', type, uploadData)
        })
        .catch(() => {
          this.uploadStatus = 'error'
        })
    }
  }
}
</script>
<style lang="scss">
@import './index.scss';
</style>
